import { ToolForAdminModel } from 'types/admin-tools/ToolForAdminModel';
import { UpdateToolByAdminModel } from 'types/admin-tools/UpdateToolByAdminModel';
import { ToolType } from 'types/tools/ToolType';
import { axiosInstance } from './apiCommon';
import { BaseQueryParams } from 'types/types';
import { ToolVerifierOption } from 'types/admin-tools/ToolVerifierOption';
import { AdminToolSearchResultItem } from 'types/admin-tools/AdminToolSearchResultItem';
import { AdminToolSearchRequest } from 'types/admin-tools/AdminToolSearchRequest';
import { ToggleToolVersionByAdminModel } from 'types/admin-tools/ToggleToolVersionByAdminModel';
import { AddToolVersionFileByAdminModel } from 'types/admin-tools/AddToolVersionFileByAdminModel';
import { PagedResult } from 'types/search-common/PagedResult';

export const postSearchTools = async (data: AdminToolSearchRequest, params?: BaseQueryParams) =>
  (await axiosInstance.post<PagedResult<AdminToolSearchResultItem>>('/api/admin/v1/tools/search', data, params)).data;

export const postCreateTool = async (toolType: ToolType) =>
  (await axiosInstance.post<string>('/api/admin/v1/tools', { toolType })).data;

export const getTool = async (toolId: string, params: BaseQueryParams) =>
  (await axiosInstance.get<ToolForAdminModel>(`/api/admin/v1/tools/${encodeURIComponent(toolId)}`, params)).data;

export const patchUpdateTool = async (toolId: string, data: UpdateToolByAdminModel) => {
  await axiosInstance.patch<ToolForAdminModel>(`/api/admin/v1/tools/${encodeURIComponent(toolId)}`, data);
};

export const postCreateToolVersion = async (toolId: string) => {
  await axiosInstance.post(`/api/admin/v1/tools/${encodeURIComponent(toolId)}/versions`);
};

export const postToggleToolVersion = async (toolId: string, versionOrd: number, data: ToggleToolVersionByAdminModel) => {
  await axiosInstance.post(`/api/admin/v1/tools/${encodeURIComponent(toolId)}/versions/${versionOrd}/toggle`, data);
};

export const postAddToolVersionFile = async (toolId: string, versionOrd: number, data: AddToolVersionFileByAdminModel) => {
  const formData = new FormData();
  formData.append('FileTypeId', data.fileTypeId);
  formData.append('FileData', data.fileData);
  await axiosInstance.post(`/api/admin/v1/tools/${encodeURIComponent(toolId)}/versions/${versionOrd}/files`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteTool = async (toolId: string) => {
  await axiosInstance.delete(`/api/admin/v1/tools/${encodeURIComponent(toolId)}`);
};

export const deleteToolVersion = async (toolId: string, versionOrd: number) => {
  await axiosInstance.delete(`/api/admin/v1/tools/${encodeURIComponent(toolId)}/versions/${versionOrd}`);
};

export const deleteToolVersionFile = async (toolId: string, versionOrd: number, fileId: string) => {
  await axiosInstance.delete(
    `/api/admin/v1/tools/${encodeURIComponent(toolId)}/versions/${versionOrd}/files/${encodeURIComponent(fileId)}`
  );
};

export const getToolVerifiers = async (params: BaseQueryParams) =>
  (await axiosInstance.get<ToolVerifierOption[]>('/api/admin/v1/tools/verifier-options', params)).data;
